<template>
    <modal size="lg" :height-max="true" @close="$emit('close')" ref="modal" :is-closeable="true" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Submit Payroll for Approval</h3>
        </template>

        <slot>
            <!-- <p class="mb-2">Select the locations to submit for approval.</p> -->

            <work-location-selector
                :all-work-locations="workLocations"
                :companies="companies"
                :employee-counts-by-location-id="employeeCountsByLocationId"
                :locked-location-ids="submittedLocationIds"
                v-model="formData.locationIds"
            />
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="$emit('close')">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Submit for Approval
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import WorkLocationSelector from '@/pages/client/Settings/components/WorkLocationSelector'

export default {
    props: ['client', 'payrollRun'],
    mixins: [FormMixin, ModalMixin],
    emits: ['close', 'submitted'],
    components: {WorkLocationSelector},
    computed: {
        workLocations() {
            return this.payrollRun.workLocations || []
        },
        companies() {
            const seen = {}
            const result = []
            for (const wl of this.workLocations) {
                if (!seen[wl.company.id]) {
                    seen[wl.company.id] = true
                    result.push(wl.company)
                }
            }
            return result
        },
        employeeCountsByLocationId() {
            const counts = {}
            for (const wl of this.workLocations) {
                counts[wl.id] = wl.employee_count != null ? wl.employee_count : 0
            }
            return counts
        },
        submittedLocationIds() {
            return this.payrollRun.submittedLocationIds || []
        },
    },
    data() {
        return {
            formData: {
                locationIds: Array.from(this.payrollRun.submittedLocationIds || []),
            },
        }
    },
    methods: {
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            const url = `/clients/${this.client.id}/payroll/runs/${this.payrollRun.id}/submit`
            this.$api.post(url, {location_ids: this.formData.locationIds}).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo('Successfully submitted payroll for approval.')
                this.$emit('submitted', resp)
                this.close()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                if (errors.__status__ == 403) {
                    this.$bus.$emit('no-access')
                    return
                }
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        },
    },
}
</script>
